import BackofficeInterceptor from '../BackofficeInterceptor'

const api = new BackofficeInterceptor()

export default {
  getTabelas() {
    return api.get(`/tabela`)
  },
}
